import { Button, Grid, Box, IconButton, Stack, Typography, Radio, TextField as MuiTextField } from '@mui/material';
import { useForm } from 'react-hook-form';
import CloseIcon from '@mui/icons-material/Close';
import { FormProvider, SelectTag, Table, TextField } from '../../../../../components';
import { useCallback, useEffect, useState } from 'react';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { dropdownFetch, request, toast } from '../../../../../utils';
import axios from 'axios';
import { BASE_URL } from '../../../../../utils';

const TABLE_HEADER = [
  {
    header: 'Donor Name',
    accessor: (row) => row?.patientName
  },
  {
    header: 'Mobie',
    accessor: (row) => row?.mobileNo
  }
];

const initialDonorDataObj = {
  data: [],
  loading: false
};
export const DonorDetailsForm = ({ onClose, onAdd, donoruseCredit }) => {
  const [input, setInput] = useState('');
  const [donorDataObj, setDonorDataObj] = useState(initialDonorDataObj);

  const methods = useForm({
    resolver: yupResolver(Yup.object().shape({})),
    defaultValues: {},
    mode: 'all'
  });
  const { handleSubmit, setValue, watch } = methods;
  const formSubmitHandler = (formValues) => {
    if (formValues.total_credit >= 1) {
      const transformedValues = {
        ...formValues
      };
      onAdd(transformedValues);
    } else {
      toast('This Donor has insufficient Credit', { variant: 'warning' });
    }
  };

  const handleInputChange = (e) => {
    setInput(e.target.value);
  };

  const handleDonorSearch = async () => {
    const lowercasedInput = input.toLowerCase().trim();
    try {
      const response = await request('/donor-calculate-total-credit', {
        method: 'GET',
        query: { name: lowercasedInput }
      });
      if (response.success && Array.isArray(response.data)) {
        setDonorDataObj({ loading: false, data: response.data });
      } else {
        toast('Error in fetching data', { variant: 'error' });
        setDonorDataObj({ loading: false, data: [] });
      }
    } catch (error) {
      console.error('Error during search:', error);
      toast('Error during search', { variant: 'error' });
      setDonorDataObj({ loading: false, data: [] });
    }
  };

  useEffect(() => {
    handleDonorSearch(input);
  }, [input]);

  const handleRowClick = (row) => {
    setValue('donor', row?.patientName);
    setValue('blood_group', row?.bloodType?.group);
    setValue('total_donation', row?.donationHistory?.totalDonationQuantity);
    setValue('total_referral', row?.donationHistory?.totalReferralQuantity);
    const donorIdToCheck = row?._id; // Assuming you want to check this specific donor's credit

    // Find the donor in donoruseCredit state
    const donor = donoruseCredit.find((donor) => donor.donorId === donorIdToCheck);

    if (donor) {
      // If the donor is found, use their credit from donoruseCredit
      setValue('total_credit', (donor?.credit || 0));
      setValue('total_referral',row?.donationHistory?.totalDonationQuantity - donor?.credit);
    } else {
      // If the donor is not found, just use totalCredit from donationHistory
      setValue('total_credit', row?.donationHistory?.totalCredit || 0);
      setValue('total_referral', row?.donationHistory?.totalReferralQuantity);
    }
    setValue('donorId', row?._id);
  };
  return (
    <Stack spacing={1} sx={{ height: '100%' }}>
      <Stack direction="row" spacing={0} alignItems="center" justifyContent="space-between" borderColor="grey.300">
        <Typography variant="h4" fontWeight="bold">
          Add Donor Details
        </Typography>
        <IconButton onClick={onClose}>
          <CloseIcon color="error" fontSize="large" />
        </IconButton>
      </Stack>
      <Stack direction="row" spacing={2} alignItems="center" justifyContent="center" sx={{ mt: 0 }}>
        <MuiTextField
          sx={{ width: '100%', padding: 0, font: '50px' }}
          label="Search Service"
          variant="outlined"
          value={input}
          onChange={handleInputChange}
          InputProps={{
            style: {
              fontSize: '14px',
              fontWeight: 600
            }
          }}
        />
      </Stack>
      <FormProvider
        sx={{ height: '100%', overflow: 'auto' }}
        methods={methods}
        onSubmit={handleSubmit(formSubmitHandler)}
      >
        <Grid container spacing={1} sx={{ flex: 1, height: '100%', overflow: 'auto' }}>
          <Grid
            item
            xs={6}
            sx={{
              height: '100%',
              overflow: 'auto',
              display: 'flex',
              flexDirection: 'column',
              gap: 1
            }}
          >
            <Table
              containerSX={{
                flex: 1,
                border: '0px solid rgba(0,0,0,0.27)',
                minHeight: '48rem',
                borderRadius: 1
              }}
              data={donorDataObj?.data || []}
              columns={TABLE_HEADER}
              size="small"
              onRowClick={(row) => {
                handleRowClick(row);
              }}
            />
          </Grid>
          <Grid item xs={6}>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.2, px: 2 }}>
              <Stack spacing={1} direction="row" alignItems="center">
                <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.4rem' }}>Donor Name</Typography>
                <TextField sx={{ flex: 0.8 }} name="donor" placeholder="Enter Donor" disabled />
              </Stack>
              <Stack spacing={1} direction="row" alignItems="center">
                <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.4rem' }}>Blood Group</Typography>
                <TextField sx={{ flex: 0.8 }} disabled name="blood_group" placeholder="Enter Blood group" />
              </Stack>
              <Stack spacing={1} direction="row" alignItems="center">
                <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.4rem' }}>Total Donation</Typography>
                <TextField
                  sx={{ flex: 0.8 }}
                  type="number"
                  inputProps={{ min: '0' }}
                  name="total_donation"
                  placeholder="Quantity"
                  disabled
                />
              </Stack>

              <Stack spacing={1} direction="row" alignItems="center">
                <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.4rem' }}>Total Referral(Used)</Typography>
                <TextField sx={{ flex: 0.8 }} name="total_referral" disabled placeholder="Total Referral" />
              </Stack>
              <Stack spacing={1} direction="row" alignItems="center">
                <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.4rem' }}>Total Credit</Typography>
                <TextField
                  sx={{ flex: 0.8 }}
                  name="total_credit"
                  type="number"
                  disabled
                  inputProps={{ min: '0' }}
                  placeholder="Net Amount"
                />
              </Stack>
              <Stack spacing={1} direction="row" alignItems="center" justifyContent="flex-end" sx={{ marginTop: '2%' }}>
                <Button variant="contained" type="submit">
                  Add
                </Button>
                <Button variant="outlined" onClick={onClose} color="error">
                  Close
                </Button>
              </Stack>
            </Box>
          </Grid>
        </Grid>
      </FormProvider>
    </Stack>
  );
};
